import Vue from 'vue';
import projectTransformer from './../../transformers/project';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(projectTransformer.fetch(errors));
};

export default (id, data) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/projects/${id}`, data)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/project/update.js